import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Form, Input, Popconfirm, Space, Table } from 'antd';
import Text from 'antd/lib/typography/Text';
import React, { useEffect, useMemo, useState, useContext, useRef } from 'react';
import { getEODParameters } from '../../../helpers/PackageJsonHelper';
import { addRole, deleteRole, editRole, getAllRoles } from '../../../networking/NetworkingRoles';
import AlertBox from '../../shared/AlertBox';
import Highlighter from 'react-highlight-words';

const RolesScreen = () => {
    const ApplicationName = useMemo(() => getEODParameters().ApplicationName, []);
    const [form] = Form.useForm();
    const [roles, setRoles] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    const [updating, setUpdating] = useState(false);

    //Search
    const [filteringSomething, setFilteringSomething] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [searchArray, setSearchArray] = useState({});
    const searchInput = useRef();

    const [editingKey, setEditingKey] = useState('');
    const [editData, setEditData] = useState({});
    const isEditing = (record) => record.key === editingKey || record.key==='AdminRoles-new';

    const edit = (record) => {
        form.setFieldsValue({
            ['Role Name']: '',
            ['Available For Online Users']: '',
            ...record,
          });        
        setEditingKey(record.key);     
        setEditData(record);
    };

    useEffect(() => {
        const loadRoles = async () => {
            const json = await getAllRoles(ApplicationName, 0, 0);
            if (json != null && json.Roles != null) {
                const _roles = json.Roles.map((r) => ({ ...r, key: `Roles-${r['Role Name']}` }));                
                setRoles(_roles);
            }
        };
        loadRoles();
    }, [ApplicationName, updating]);

    const save = async (record) => {
        try {
            const row = await form.validateFields();            
            const roleName = editingKey === '' ? row['Role Name'] : editData['Role Name'];
            const available = row['Available For Online Users'];
            console.log('Model');
            console.log(row);
            let json;
            if (editingKey === '') {
                json = await addRole('ForeignExchange', roleName, available);
            } else {
                json = await editRole('ForeignExchange', roleName, available);
            }            
            if (json != null) {
                if (json.httpStatusCode === 200) {
                    setShowAlert(true);
                    setAlertTitle('Success');
                    setAlertMessage('Role successfully saved.');

                    form.resetFields();
                } else {
                    setShowAlert(true);
                    setAlertTitle('Error');
                    setAlertMessage(json.Message);
                }
                setEditingKey('');
                setEditData({});
                setUpdating(!updating);
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };   

    const deleteRecord = async (record) => {
        const json = await deleteRole('ForeignExchange', record['Role Name']);
        if (json != null) {
            if (json.httpStatusCode === 200) {
                setShowAlert(true);
                setAlertTitle('Success');
                setAlertMessage(json.Message);
            } else {
                setShowAlert(true);
                setAlertTitle('Error');
                setAlertMessage(json.Message);
            }
            setEditingKey('');
            setUpdating(!updating);
        }
    };

    const cancel = (page) => {
        setEditingKey('');
        if (typeof page === 'number') {
            setCurrentPage(page);
        }

        if (roles[0]['Role Name'] === '') {
            let auxRoles = [...roles];
            auxRoles.shift();
            setRoles(auxRoles);
        }
        form.resetFields();        
    };

    const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
        const onChange = (e) => {
            form.setFieldsValue({ 'Available For Online Users': e.target.checked });
        };
        let inputNode = <Input style={{ textAlign: 'center' }} />;
        if (inputType === 'check') {
            inputNode = (
                <Checkbox onChange={onChange} defaultChecked={record['Available For Online Users']}>
                    Available For Online Users
                </Checkbox>
            );
        }
        let styleEdit = { margin: 0 };
        if ((record !== undefined && record.isNew !== undefined && record.isNew === true) || editing) {
            styleEdit = {
                paddingBottom: 10,
                paddingTop: 10,
                margin: 0
            };
        }

        const getCustomRules = (columnDataIndex) => {
            switch (columnDataIndex) {
                case 'Markup Factor': {
                    return [
                        {
                            type: 'boolean',
                            mesage: 'Please Input a valid value!'
                        }
                    ];
                }
                default:
                    return [
                        {
                            required: true,
                            message: `Please Input a ${title}!`
                        }
                    ];
            }
        };
        const rules = getCustomRules(dataIndex);

        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item name={dataIndex} style={styleEdit} rules={rules} valuePropName={inputType === 'text' ? 'value' : 'checked'}>
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };

     //Search
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    setFilteringSomething(true);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
    setFilteringSomething(false);
  };

  const settingSearchStateValues = (value, col) => {
    setSearchText(value);
    setSearchedColumn(col);
    setSearchArray(...(searchArray[col] = value));
    setFilteringSomething(true);
  };
  //


    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref         = {(node) => {
                searchInput.current = node;
              }}
              placeholder = {`Search ${dataIndex}`}
              value       = {selectedKeys[0]}
              onChange    = {(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{
                width       : 188,
                marginBottom: 8,
                display     : 'block'
              }}
            />
            <Space>
              <Button 
                type    = "primary" 
                onClick = {() => handleSearch(selectedKeys, confirm, dataIndex)} 
                icon    = {<SearchOutlined />} 
                size    = "small" 
                style   = {{ width: 90 }}
              >
                Search
              </Button>
              <Button
                onClick={() => {
                    handleReset(clearFilters);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
              <Button
                type    = "link"
                size    = "small"
                onClick = {() => {
                  confirm({ closeDropdown: false });
                  settingSearchStateValues(selectedKeys[0], dataIndex);
                }}
              >
                Filter
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) => (record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : ''),
        onFilterDropdownVisibleChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current.select(), 100);
          }
        },
        render: (text) => (
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : ( text )
        )
      });


    const columns = [
        {
            title: 'Role Name',
            dataIndex: 'Role Name',
            width: '10%',
            editable: true && editingKey === '',
            align: 'center',
            sorter: (a, b) => {
                return a['Role Name'].localeCompare(b['Role Name']);
            },
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('Role Name'),
            
        },
        {
            title: 'Available For Online Users',
            dataIndex: 'Available For Online Users',
            width: '10%',
            editable: true,
            align: 'center',
            sorter: (a, b) => {
                return a['Available For Online Users'].localeCompare(b['Available For Online Users']);
            },
            sortDirections: ['descend', 'ascend'],
            render: (_, record) => <Text>{record['Available For Online Users'] ? 'Yes' : 'No'}</Text>
        },
        {
            title: 'Actions',
            dataIndex: 'Actions',
            align: 'center',
            width: '15%',
            render: (_, record) => {                
                const editable = isEditing(record);                
                return editable ? (
                    <span>                        
                        <Popconfirm title="Sure to save?" onConfirm={() => save(record)}>
                            <a style={{ marginRight: 8 }}>Save</a>
                        </Popconfirm>
                        <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                            <a>Cancel</a>
                        </Popconfirm>
                    </span>
                ) : (
                    <div>
                        <Space size="middle">
                            <a onClick = {() => edit(record)} disabled={editingKey!=='' && editingKey !== record.key}> Edit </a>
                            <Popconfirm title="Sure to delete?" onConfirm={() => deleteRecord(record)}>
                                <a disabled={editingKey !== '' || roles[0]['Role Name'] === ''}>Delete</a>
                            </Popconfirm>
                        </Space>
                    </div>
                );
            }
        }
    ].map((col) => {        
        if (!col.editable) {
            return col;
        }
        let type = 'text';
        if (col.dataIndex === 'Available For Online Users') {
            type = 'check';
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: type,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record)
            })
        };
    });

    const addNewRole = () => {
        let actual = [...roles];
        if (actual[0] != null && actual[0]['Role Name'] === '') {
            return;
        } else {
            actual.unshift({
                'key': 'AdminRoles-new',
                'Role Name': '',
                'Available For Online Users': false,
                UpdateToken: '',
                isNew: true
            });
            setRoles(actual);
            setCurrentPage(1);
            form.setFieldsValue({
                'Role Name': '',
                'Available For Online Users': false,
                ...actual
            });
            // setCurrentUpdateToken('');
        }
    };

    const closeAlert = () => {
        setShowAlert(false);
    };

    function itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }
        
    return (
        
        <div>
            <div className="breadcrumb-div">
                <Breadcrumb separator=">">
                    <Breadcrumb.Item className="breadcrumb-item-bold">Admin Roles</Breadcrumb.Item>
                </Breadcrumb>
            </div>
            <Form form={form}>
                <Table dataSource={roles} columns={columns} size="small" components={{ body: { cell: EditableCell } } }
                pagination={{
                    onChange: cancel,
                    showQuickJumper: true,
                    itemRender: itemRender,
                    current: currentPage,
                    defaultCurrent: 1,
                    size: 'default'
                }}
                footer={() => (
                    <Button
                        type="dashed"
                        onClick={addNewRole}
                        block
                        icon={<PlusOutlined />}
                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                        disabled={editingKey !== '' || (roles[0] !== undefined && roles[0]['Role Name'] === '')}
                    >
                        Add a Role
                    </Button>
                )}/>
            </Form>
            <AlertBox open={showAlert} onClose={closeAlert} title={alertTitle} message={alertMessage} type="Ok" okClick={closeAlert} />
        </div>
    );
};

export default RolesScreen;
